import React, { useState } from 'react';
import './MoodGames.css';

/**
 * TinyWins — a gentle lift for a low day. Pick one small thing you managed today,
 * however small; the game responds with a warm, encouraging note. No streaks, no
 * pressure — one tap is enough, and it's easy to leave.
 */
const WINS = [
  { emoji: '🛏️', label: 'Got out of bed' },
  { emoji: '💧', label: 'Drank some water' },
  { emoji: '💬', label: 'Replied to a message' },
  { emoji: '🚶', label: 'Moved a little' },
  { emoji: '🧹', label: 'Tidied one small thing' },
  { emoji: '🫶', label: 'Was kind to myself' },
  { emoji: '✅', label: 'Showed up today' },
];

export const TinyWins: React.FC = () => {
  const [chosen, setChosen] = useState<string | null>(null);

  return (
    <div className="mm-game mm-game--wins">
      <div className="mm-game__head">
        <h3 className="mm-game__title">Tiny Wins</h3>
        <p className="mm-game__sub">Pick one thing you managed today — it counts.</p>
      </div>

      {chosen ? (
        <div className="mm-game__done">
          <span className="mm-game__done-emoji">🌼</span>
          <span className="mm-game__done-title">That counts. Truly.</span>
          <span className="mm-game__done-sub">“{chosen}” is a real win on a hard day. Be gentle with yourself.</span>
          <button type="button" className="mm-game__btn mm-game__btn--ghost" onClick={() => setChosen(null)}>Pick another</button>
        </div>
      ) : (
        <div className="mm-wins__list" role="group" aria-label="Small wins">
          {WINS.map((w) => (
            <button key={w.label} type="button" className="mm-wins__item" onClick={() => setChosen(w.label)}>
              <span className="mm-wins__item-emoji" aria-hidden="true">{w.emoji}</span>
              <span>{w.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TinyWins;
